module.exports = __webpack_public_path__ + "static/media/calenda.3a2ea662.svg";